<div class="infinite-select" [class.calendar]="location() === 'calendar'">
  <button
    type="button"
    class="infinite-select-trigger"
    [ngClass]="triggerClass"
    (click)="toggle()"
    [disabled]="disabled"
  >
    <span class="description-content">{{ displayLabel || placeholder }}</span>
    <span class="infinite-select-caret" *ngIf="showCaret"></span>
  </button>

  <div
    class="infinite-select-panel dropdown-menu show"
    [ngClass]="panelClass"
    *ngIf="isOpen"
  >
    <div class="infinite-select-search" *ngIf="searchEnabled">
      <input
        type="text"
        class="form-control form-control-sm"
        [placeholder]="searchPlaceholder"
        (input)="onSearchInput($event)"
      />
    </div>

    <div
      class="infinite-select-options"
      [style.maxHeight.px]="panelMaxHeight"
      (scroll)="onPanelScroll($event)"
    >
      <p
        class="dropdown-item mb-0"
        *ngIf="allOptionLabel"
        (click)="selectValue(allOptionValue)"
        (keydown.enter)="selectValue(allOptionValue)"
        (keydown.space)="selectValue(allOptionValue); $event.preventDefault()"
        [class.active]="selectedValue === allOptionValue"
        role="button"
        tabindex="0"
      >
        {{ allOptionLabel }}
      </p>

      <p
        class="dropdown-item mb-0"
        *ngFor="let item of items; trackBy: trackByItem"
        (click)="selectItem(item)"
        (keydown.enter)="selectItem(item)"
        (keydown.space)="selectItem(item); $event.preventDefault()"
        [class.active]="isSelected(item)"
        role="button"
        tabindex="0"
      >
        {{ resolveLabel(item) }}
      </p>

      <div
        class="dropdown-item text-muted"
        *ngIf="!loading && items.length === 0 && !errorMessage"
      >
        Sin resultados
      </div>

      <div class="dropdown-item text-danger" *ngIf="errorMessage">
        <span>{{ errorMessage }}</span>
        <button type="button" class="btn btn-link btn-sm p-0 ms-2" (click)="retry()">
          Reintentar
        </button>
      </div>

      <div class="dropdown-item text-center" *ngIf="loading">
        <span class="spinner-border spinner-border-sm text-secondary" role="status" aria-hidden="true"></span>
      </div>
    </div>
  </div>
</div>
